export default __webpack_public_path__ + "assets/2ebfcd3a6ffc6d095f650819412af64f.jpg";